import type { ReactNode } from 'react';
import styles from './DeliveryDetailDrawer.module.css';

/** One label/value pair in a record drawer's Overview `dl` — shared by the
 *  delivery and stock detail drawers, which render the same field anatomy. */
export function DetailField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className={styles.field}>
      <dt className={styles.fieldLabel}>{label}</dt>
      <dd className={styles.fieldValue}>{children}</dd>
    </div>
  );
}
